import type { Schema } from '@dealdesk/api-schema';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '@/shared/api/client';
import { STALE } from '@/shared/api/stale';

import { employerKeys, type EmployerListParams } from './keys';

export { lookupsQuery } from '@/shared/lookups';

export const employersQuery = (p: EmployerListParams) =>
  queryOptions({
    queryKey: employerKeys.list(p),
    queryFn: ({ signal }) => unwrap(api.GET('/employers', { params: { query: p }, signal })),
    staleTime: STALE.list,
    placeholderData: keepPreviousData,
  });

export const employerQuery = (id: string) =>
  queryOptions({
    queryKey: employerKeys.detail(id),
    queryFn: ({ signal }) => unwrap(api.GET('/employers/{employerId}', { params: { path: { employerId: id } }, signal })),
    staleTime: STALE.record,
  });

export const duplicatesQuery = queryOptions({
  queryKey: employerKeys.duplicates(),
  queryFn: ({ signal }) => unwrap(api.GET('/employers/duplicates', { signal })),
  staleTime: STALE.list,
});

export const enlistmentsQuery = (p: { status?: Schema<'EnlistmentStatus'>[]; bank?: string }) =>
  queryOptions({
    queryKey: employerKeys.enlistments(p),
    queryFn: ({ signal }) => unwrap(api.GET('/enlistments', { params: { query: { ...(p.status?.length ? { status: p.status } : {}), ...(p.bank ? { bank: p.bank } : {}) } }, signal })),
    staleTime: STALE.queue,
    placeholderData: keepPreviousData,
  });

/** A bank's employer category catalogue (reference data). */
export const employerCategoriesQuery = (bankId: string) =>
  queryOptions({
    queryKey: employerKeys.categories(bankId),
    queryFn: ({ signal }) => unwrap(api.GET('/banks/{bankId}/employer-categories', { params: { path: { bankId } }, signal })),
    staleTime: STALE.reference,
  });

/** Customer employments whose employer is not in the master ("Not in master"), oldest first. */
export const unresolvedEmploymentsQuery = queryOptions({
  queryKey: employerKeys.unresolved(),
  queryFn: ({ signal }) => unwrap(api.GET('/employers/unresolved', { signal })),
  staleTime: STALE.list,
});
